<template>
	<div class="p-fixed_bottom flexs ptbrl-15-40 box-s bs_radius text-center" :class="{ 'pl-23': isAnswer }">
    <div class="pt-2 box-s" :class="{ 'mrb-26': isAnswer }" v-if="isAnswer" @click="getAnswer">
      <img v-if="!answerFalg" class="wh-18 mb-7 m0-auto" src="../assets/img/icon/answer1.png" alt="">
      <img  v-else class="wh-18 mb-7 m0-auto" src="../assets/img/icon/answer2.png" alt="">
      <div class="fz-12 c1 l-h-10" :class="{ c2: answerFalg }">答案</div>
    </div>
	  <div @click="collect">
      <img v-if="collectFalg" class="wh_20 mb-7 m0-auto" src="../assets/img/icon/collection_ok_icon.png" alt="">
      <img  v-else class="wh_20 mb-7 m0-auto" src="../assets/img/icon/collection_icon.png" alt="">
      <div class="fz-12 c1 l-h-10">收藏</div>
    </div>

    <div class="mlr-30-40" :class="{ 'mlr-17-20': isAnswer }" @click="quertCard">
      <img class="wh_20 mb-7 m0-auto" src="../assets/img/icon/card_icon.png" alt="">
      <div class="fz-12 c1 l-h-10" >答题卡</div>
    </div>

    <div class="btn_top_quest btn_top_quest_b mr-20" :class="{ 'btn_top_quest_gray': qusetNum == 1 || (present_question_num && (present_question_num == 1)) }" @click="getQuest('1')">上一题</div>

    <div class="btn_top_quest btn_top_quest_l" @click="getQuest('2')" :class="{ 'btn_top_quest_gray': !questBtn && (length != 1 && qusetNum == length || (present_question_num && (present_question_num == length)))}" >{{ questBtn && (length != 1 && qusetNum == length || (present_question_num && (present_question_num == length)))? '提交':'下一题' }}</div>
	</div>
</template>
<script>
  import { collectWrongSecondEdition, collectWrongWord  } from '@/api/api.js'
	export default {
		props: {
      qusetNum: {
        type: Number,
        default: 1
      },
      length: {
        type: Number,
        default: 1
      },
      collectFalg: {
        type: Boolean,
        default: false
      },
      isAnswer: {
        type: Boolean,
        default: false
      },
      materLength: {
        type: Number,
        default: 0
      },
      answerFalg: {
        type: Boolean,
        default: false
      },
      cData: {
        type: Object,
        default(){
          return {
            question_id: '',
            model_type: '',
            way: 2, 
            base_id: '', 
            base_user_id: ''
          }
        }
      },
      present_question_num: {
        type: Number,
        default: 0
      },
      wrong: {
        type: Boolean,
        default: false
      },

      wrong_id: {
        type: Number,
        default: 0
      },
      questBtn: {
        type: Boolean,
        default: true
      }
		},
		data() {
			return {
			}
		},
		mounted() {
    },
		methods: {
      // 收藏
      async collect(){
        const status = this.collectFalg? 2:1
        if(this.wrong){
          const res = await collectWrongWord({ wrong_id: this.wrong_id,status: status })
          if(res.code == 1000){
            !this.collectFalg && this.$toast('已收藏至错题本')
            this.collectFalg && this.$toast('已取消收藏错题本')
            this.$emit('collect', this.collectFalg)
          } else {
            this.$toast(res.msg)
          }
        } else {

          const { model_type, question_id, way, base_id, base_user_id } = this.cData
          const form = { model_type, question_id,way, base_id, base_user_id,status: status }
          const res = await collectWrongSecondEdition(form)
          if(res.code == 1000){
            !this.collectFalg && this.$toast('已收藏至错题本')
            this.collectFalg && this.$toast('已取消收藏错题本')
            this.$emit('collect', this.collectFalg)
          } else {
            this.$toast(res.msg)
          }
        }

        
        
      },

      // 答题卡
      quertCard(){
        this.$emit('quertCard')
      },

      // 上一题、下一题
      getQuest(type){
        if(this.qusetNum == 1 && type == '1' || (this.present_question_num && (this.present_question_num == 1) && type == '1')){
          return this.$toast('前面没有题目了哦~')
        } else if (this.qusetNum == this.length && type == '2' || (this.present_question_num && (this.present_question_num == this.length) && type == '2')) {
          this.$toast({
            message: '已经是最后一题了哦~',
            duration: 2000
          })
          setTimeout(()=>{
            this.$emit('quertCard', 1)
          }, 2000)

          return
        }
        this.$emit('getQuest', type)
      },
      getAnswer(){
        console.log(11)
        this.$emit('getAnswer')
      }
		}
	}
</script>
<style lang="less" scoped>

</style>
